import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';
import { enqueueSnackbar } from '../../notifier/actions';

import {
  FETCH_PRODUCT_MEMBERS_STARTED,
  fetchProductMembersFulfilled,
  UPDATE_PRODUCT_MEMBER_ROLE_STARTED,
  updateProductMemberRoleFulfilled,
} from './actions';

const fetchProductMembersEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_PRODUCT_MEMBERS_STARTED),
    mergeMap((action: { payload: unknown }) =>
      from(Safescarf.fetchSafescarfProductMembers(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(fetchProductMembersFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const updateProductMemberRoleEpic: Epic = action$ =>
  action$.pipe(
    ofType(UPDATE_PRODUCT_MEMBER_ROLE_STARTED),
    mergeMap((action: { payload: Record<string, unknown> }) =>
      from(Safescarf.updateProductMemberRole(action.payload)).pipe(
        mergeMap((response: { data: unknown }) =>
          of(
            updateProductMemberRoleFulfilled(response.data),
            enqueueSnackbar({
              message: 'safescarfProductMemberUpdated',
              options: { variant: 'success' },
            })
          )
        ),
        catchError(handleError)
      )
    )
  );

export default combineEpics(fetchProductMembersEpic, updateProductMemberRoleEpic);
